var heading_default = {
  "fontElementMap": "_9L5Vg",
  "elementSpacing": "b3yOZ",
  "headerOne": "_1YufR b3yOZ",
  "headerTwo": "bk4bG b3yOZ",
  "headerThree": "Njwtn b3yOZ",
  "headerFour": "GytJZ b3yOZ",
  "headerFive": "jbihE b3yOZ",
  "headerSix": "_6Zdwj b3yOZ",
  "child": "Tcz9z"
};
export {
  heading_default as default
};
//# sourceMappingURL=heading-scss.js.map
